import * as React from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import {  Gauge, gaugeClasses } from '@mui/x-charts/Gauge';
import * as util from "../utils/util";

function CircularProgressWithLabel(props :any) {
  
  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}  className='CircleChart'   >
      {/* <CircularProgress variant="determinate" {...props} className='CircleChart' sx={{color:"#EF8322"}}  /> */}
      <Gauge width={100} height={100} value={props.progress.value/props.progress.goal*100} className='CircleChart' 
       cornerRadius="50%"
       sx={ ({
         [`& .${gaugeClasses.valueText}`]: {
           fontSize: 20,
           display:'none'
         },
         [`& .${gaugeClasses.valueArc}`]: {
           fill: '#EF8322',
         },
         [`& .${gaugeClasses.referenceArc}`]: {
           fill: '#eaeaea'
         },
       })}
      />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography
          variant="caption"
          component="div"
          className='circleText'
          color="#aaa"
          fontSize={18}
          fontWeight={700}
        >{`${util.formatComma(Math.round(props.progress.goal))}`}</Typography>
      </Box>
    </Box>
  );
}

export default CircularProgressWithLabel;